import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";
import Tick from "../../../../assets/images/Tick.png";

const fontFiles = [
  {
    src: "/Inter/static/Inter_18pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
];

fontFiles.forEach((font) => {
  Font.register({
    family: "Inter",
    fonts: [
      {
        src: font.src,
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
      },
    ],
  });
});

const styles = StyleSheet.create({
  page: { padding: 10, fontSize: 12, fontFamily: "Inter", paddingBottom: 35 },
  submission_document: {
    color: "#fff",
    backgroundColor: "#6947B0",
    padding: 10,
    fontSize: 14,
    fontWeight: 700,
  },
  section1: {
    fontWeight: 600,
    marginTop: 10,
    marginBottom: 10,
  },
  section1_split: {
    flexDirection: "row",
    backgroundColor: "#F5F6F7",
    padding: 8,
    justifyContent: "space-between",
    borderRadius: 5,
    gap: 10,
    flexWrap: "wrap",
  },
  section1_split_inner: {
    flexDirection: "row",
  },
  section1_split_inner_title: {
    fontSize: 9,
    fontWeight: 700,
  },
  section1_split_inner_text: {
    fontSize: 9,
    fontWeight: 500,
  },
  justication_body: {
    backgroundColor: "#F5F6F7",
    padding: 8,
    borderRadius: 5,
  },
  footer: {
    position: "absolute",
    right: 12,
    bottom: 12,
    fontSize: 9,
    fontWeight: 600,
  },

  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#fff",
    // borderWidth: 1,

    borderBottomWidth: 1,
    backgroundColor: "#F5F6F7",
  },
  rowHeader: {
    backgroundColor: "#F7F8F9",
    flexDirection: "row",

    borderTopWidth: 0,
    // borderLeftWidth: 2,
    // borderRightWidth: 2,
    borderColor: "#fff",
  },
  row: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderBottomWidth: 1,

    borderColor: "#fff",
  },
  tableWrapper: {
    flexDirection: "column",
    flexWrap: "wrap",
  },
  cellHeader: {
    backgroundColor: "#7F56D9",
    fontWeight: 600,
    padding: 5,
    fontSize: 9,
    borderLeftWidth: 1.5,
    color: "#fff",
    borderStyle: "solid",
    borderColor: "#fff",
  },
  cell: {
    padding: 5,
    // width: "25%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    fontWeight: 500,
    fontSize: 9,
    borderStyle: "solid",
    borderColor: "#fff",
    wordBreak: "break-word",
  },

  section_supporting: {
    flexDirection: "row",
    gap: 10,
    flexWrap: "wrap",
    width: "100%",
  },
  section_supporting_title: {
    fontWeight: 500,
    fontSize: 9,
    // wordBreak: "break-all",
  },

  section_supporting_split: {
    backgroundColor: "#F5F6F7",
    padding: 7,
    borderRadius: 5,
    flexDirection: "row",
    gap: 10,
    justifyContent: "space-between",
  },
  end_of_document: {
    fontSize: 11,
    fontWeight: 400,
    color: "#475467",
    textAlign: "center",
    marginTop: 30,
  },
});

export default function JustificationPDF({ values }) {
  console.log(values, "values", values?.client);
  const tableHeader = [
    { title: "Skill", width: "15%" },
    { title: "Rating out 5", width: "15%" },
    { title: "Relevancy", width: "15%" },
    { title: "Experience In Years", width: "15%" },
    { title: "comments", width: "40%" },
  ];

  const riskTableHeader = [
    { title: "Potential Risk", width: "42.5%" },
    { title: "Remediation", width: "42.5%" },
    { title: "Risk", width: "15%" },
  ];

  const jobDetails = [
    {
      title: "Job Title :",
      value: values.position_title,
    },
    {
      title: "Job / Req ID :",
      value: values.job_id || "-",
    },
    {
      title: "Job Name :",
      value: values.first_name || "-",
    },
    {
      title: "Client Name :",
      value: values.client || "-",
    },
  ];

  function parseMarkdown(text) {
    const lines = text?.split("\n") || [];

    return lines.map((line, index) => {
      const trimmed = line.trim();

      if (!trimmed) {
        return <Text key={index} style={{ marginBottom: 6 }} />;
      }

      // Headings (## or #)
      if (/^#+\s*/.test(trimmed)) {
        const heading = trimmed.replace(/^#+\s*/, "");
        return (
          <View key={index}>
            <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 2 }}>
              {heading}
            </Text>
            <Text style={{ marginBottom: 6 }}>{""}</Text>{" "}
          </View>
        );
      }

      // Bullet points
      if (/^[-•]\s*/.test(trimmed)) {
        const content = trimmed.replace(/^[-•]\s*/, "");
        const boldMatch = content.match(/\*\*(.*?)\*\*/);

        if (boldMatch) {
          const before = content.slice(0, boldMatch.index);
          const boldText = boldMatch[1];
          const after = content.slice(boldMatch.index + boldText.length + 4);

          return (
            <Text key={index} style={{ fontSize: 10, marginBottom: 4 }}>
              • {before}
              <Text style={{ fontWeight: "bold" }}>{boldText}</Text>
              {after}
            </Text>
          );
        }

        return (
          <Text key={index} style={{ fontSize: 10, marginBottom: 4 }}>
            • {content}
          </Text>
        );
      }

      // Inline bold (e.g., "Name: **Karthik**")
      const boldMatch = trimmed.match(/\*\*(.*?)\*\*/);
      if (boldMatch) {
        const before = trimmed.slice(0, boldMatch.index);
        const boldText = boldMatch[1];
        const after = trimmed.slice(boldMatch.index + boldText.length + 4);

        return (
          <Text key={index} style={{ fontSize: 10, marginBottom: 4 }}>
            {before}
            <Text style={{ fontWeight: "bold" }}>{boldText}</Text>
            {after}
          </Text>
        );
      }

      // Plain line
      return (
        <Text key={index} style={{ fontSize: 10, marginBottom: 4 }}>
          {trimmed}
        </Text>
      );
    });
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.submission_document}>
          Candidate Justification Summary
        </Text>

        <Text style={styles.section1}>Job Details</Text>

        <View style={styles.section1_split}>
          {jobDetails.map((item) => (
            <View style={styles.section1_split_inner}>
              <Text style={styles.section1_split_inner_title}>
                {item.title}{" "}
              </Text>
              <Text style={styles.section1_split_inner_text}>{item.value}</Text>
            </View>
          ))}
        </View>

        <Text style={{ ...styles.section1, marginTop: 10 }}>Justification</Text>

        <View style={styles.justication_body}>
          {parseMarkdown(values.candidate_fit_summary)}
        </View>

        <Text style={{ ...styles.section1, marginTop: 10 }}>Skills</Text>

        <View style={styles.tableWrapper}>
          <View style={styles.table}>
            <View style={styles.rowHeader}>
              {tableHeader.map((item) => (
                <Text style={[styles.cellHeader, { width: item.width }]}>
                  {item.title}
                </Text>
              ))}
            </View>

            {(values.skills_summary || []).map((item, i) => {
              return (
                <View wrap={false} key={i} style={styles.row}>
                  <Text style={[styles.cell, { width: "15%" }]}>
                    {item.skill}
                  </Text>
                  <Text
                    style={[
                      styles.cell,
                      {
                        width: "15%",
                        fontWeight: 600,
                        color:
                          item.rating <= 2
                            ? "#C9372C"
                            : item.rating <= 3
                            ? "#DC6803"
                            : "#DC6803",
                        backgroundColor:
                          item.rating <= 2
                            ? "#FFD5D2"
                            : item.rating <= 3
                            ? "#FEEFC6"
                            : "#DBFAE6",
                      },
                    ]}
                  >
                    {item.rating}
                  </Text>
                  <Text style={[styles.cell, { width: "15%" }]}>
                    {item.relevancy}
                  </Text>
                  <Text style={[styles.cell, { width: "15%" }]}>
                    {item.experience_in_yrs}
                  </Text>
                  <Text
                    style={[
                      styles.cell,
                      {
                        width: "40%",
                      },
                    ]}
                  >
                    {item.comment}
                  </Text>
                </View>
              );
            })}
          </View>
        </View>

        <Text style={{ ...styles.section1, marginTop: 10 }}>
          Supporting Evidence
        </Text>

        <View style={styles.section_supporting}>
          {(values.supporting_evidence || []).map((item, index) => (
            <View
              key={index}
              style={{ ...styles.section_supporting_split, width: "49%" }}
            >
              <Text
                style={{ ...styles.section_supporting_title, width: "95%" }}
              >
                {item}
              </Text>
              <View style={{ width: "5%" }}>
                <Image src={Tick} width="100%" height="100%" />
              </View>
            </View>
          ))}
        </View>
        {/* <Text style={{ ...styles.section1, marginTop: 10 }}>Risk Analysis</Text>
        <View style={styles.tableWrapper}>
          <View style={styles.table}>
            <View style={styles.rowHeader}>
              {riskTableHeader.map((item) => (
                <Text style={[styles.cellHeader, { width: item.width }]}>
                  {item.title}
                </Text>
              ))}
            </View>

            {(values.risks_and_remediation || []).map((item, i) => {
              return (
                <View wrap={false} key={i} style={styles.row}>
                  <Text style={[styles.cell, { width: "42.5%" }]}>
                    {item.risk}
                  </Text>
                  <Text style={[styles.cell, { width: "42.5%" }]}>
                    {item.remediation}
                  </Text>
                  <Text
                    style={[
                      styles.cell,

                      {
                        width: "15%",
                        fontWeight: 600,
                        color:
                          item.rating <= "High"
                            ? "#C9372C"
                            : item.rating <= "Medium"
                            ? "#DC6803"
                            : "#DC6803",
                        backgroundColor:
                          item.rating <= "High"
                            ? "#FFD5D2"
                            : item.rating <= "Medium"
                            ? "#FEEFC6"
                            : "#DBFAE6",
                      },
                    ]}
                  >
                    {item.risk_level}
                  </Text>
                </View>
              );
            })}
          </View>
        </View> */}
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}
